document.addEventListener("keydown", function(event) {
    const comingSoonTrigger = event.target.closest("[data-coming-soon-action='true']");

    if (event.key === "Escape") {
        document.querySelectorAll("[data-coming-soon-tooltip='true']").forEach((element) => {
            window.bootstrap.Tooltip.getInstance(element)?.hide();
        });
        return;
    }

    if (!comingSoonTrigger) {
        return;
    }

    if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
    }
});
